module.exports = __webpack_public_path__ + "img/icon-14-b.0fa6eca8.png";